// Local translations
export const T = {
  en_GB: {
    preview: "Preview",
    selectSession: "Select a session to preview",
    noCompletedSessions: "No completed sessions available for preview",
    generating: "Generating...",
    failedToCreate: "Failed to generate preview",
  },
  nb_NO: {
    preview: "Forhåndsvisning",
    selectSession: "Velg en sesjon for forhåndsvisning",
    noCompletedSessions: "Ingen fullførte sesjoner tilgjengelig for forhåndsvisning",
    generating: "Genererer...",
    failedToCreate: "Kunne ikke generere forhåndsvisning",
  },
} as const;
